/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-14 13:57:49
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-15 18:50:36
 */
import { API_PREFIX } from './constant'
import { Request } from './request'

// 列表
export interface DBManagementListParams {
  materialsName?: any
  current?: any
  size?: any
  createTimeEnd?:any
  createTimeStart?:any
  examineStatus?:any
}

export function getDBManagementList(params: DBManagementListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/list`,
    method: 'GET',
    params,
  }
}

// 详情
export function getDBManagementDetail(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/detail`,
    method: 'GET',
    params: {
      id,
    },
  }
}

// 导出
export function getDBManagementExport(params: DBManagementListParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/`,
    method: 'POST',
    responseType: 'blob',
    params,
  }
}

// 保存编辑
export interface SubmitParams {
  id?: any
  tenantMaterialsName?: any
  tenantMaterialsCatalogId?: any
  reportLossNumber?: any
  reportLossReason?: any
  reportLossDate?: any
  reportLossUser?: any
  handleSuggestion?: any
  handleResult?: any
  remark?: any
  tenantInventoryLedgerId?:any
}

export function getDBManagementSubmit(body: SubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/submit`,
    method: 'POST',
    body,
  }
}

// 删除
export function getRemove(ids: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/remove`,
    method: 'GET',
    params: {
      ids,
    },
  }
}


// 审核
export function getExamine(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/examine`,
    method: 'GET',
    params: {
      id,
    },
  }
}

// 报损
export function getBreakage(reason: any): Request {
  return {
    url: `${API_PREFIX}/blade-store/gspdruglossm/importExpired`,
    method: 'GET',
    params: {
      reason,
    },
  }
}


